'use client'

import { JOB_TYPE_CONFIG } from '@/lib/validations'
import type { JobType } from '@/types/api.types'

interface JobTypeBadgeProps {
  type: JobType
}

export function JobTypeBadge({ type }: JobTypeBadgeProps) {
  const config = JOB_TYPE_CONFIG[type]
  if (!config) return null

  return (
    <span
      className="inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium"
      style={{
        fontFamily: 'var(--font-inter, Inter, sans-serif)',
        color: config.color,
        backgroundColor: 'var(--color-bg-elevated)',
        border: `1px solid ${config.color}`,
        opacity: 0.9,
      }}
    >
      {config.label}
    </span>
  )
}
